import styled from '@emotion/styled';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(12)};
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  padding: ${rem(16)};
  width: 100%;
`;

const CardTitle = styled.h4`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(14)};
  font-weight: 600;
  line-height: ${rem(20)};
  margin: 0;
`;

const Body = styled.p`
  color: ${({ theme }) => theme.palette.grey['600']};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(20)};
  margin: 0;
`;

const Value = styled.p`
  color: ${({ theme }) => theme.palette.violet.medium};
  font-size: ${rem(24)};
  font-weight: 700;
  line-height: ${rem(30)};
  margin: 0;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(16)};
  margin: 0;
`;

export default {
  Root,
  CardTitle,
  Body,
  Value,
  Description
};
